import React from "react";
import { PageMode } from "../enums";
import { SectionHeaderWrapper } from "../../../../../shared/SectionHeaderWrapper";
import { DOCS_WEBHOOKS_MERGE_TO_YOU_PATH } from "../../../../../../router/RouterUtils";
interface AddEditWebhooksPageHeaderProps {
  children: React.ReactNode;
  mode: PageMode;
}

function AddEditWebhooksPageHeader({ mode, children }: AddEditWebhooksPageHeaderProps) {
  return (
    <SectionHeaderWrapper
      title={
        mode === PageMode.EDIT ? "Edit webhook from Merge to you" : "Add webhook from Merge to you"
      }
      subtitle="Configure your webhook to send a POST request to the designated URL"
      docsUrl={DOCS_WEBHOOKS_MERGE_TO_YOU_PATH}
    >
      {children}
    </SectionHeaderWrapper>
  );
}

export default AddEditWebhooksPageHeader;
